// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3TVAR","footer-links":"footer_footer-links__3EMoP","type":"footer_type__3xG2j","rights":"footer_rights__aNuAQ"};